import { makeStyles } from '@material-ui/core/styles';
import { BackgroundColors, TextColors, TextOpacities, SecondaryColors } from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '& .MuiPopover-paper': {
        backgroundColor: BackgroundColors.dark,
        color: TextColors.light,
        padding: '24px',
      },
    },
    filterColumnTitle: {
      marginBottom: muiTheme.spacing(2),
    },
    columns: {
      padding: muiTheme.spacing(3),

      '& .column': {
        paddingTop: 0,
        paddingBottom: 0,

        '&:first-child': {
          paddingLeft: 0,
        },

        '&:last-child': {
          paddingRight: 0,
        },

        '&:not(:first-child)': {
          paddingLeft: muiTheme.spacing(3),
        },

        '&:not(:last-child)': {
          borderRight: `1px solid ${hexToRGBA(TextColors.light, TextOpacities.light4)}`,
          paddingRight: muiTheme.spacing(3),
        },
      },

      '& .filter-checkbox .MuiFormControlLabel-root': {
        marginLeft: 0,
      },
    },
    columnHead: {
      '&.MuiTypography-root': {
        margin: muiTheme.spacing(0, 0, 2, 1.125),
        lineHeight: 'normal',
      },
    },
    closeAndApply: {
      margin: muiTheme.spacing(3, 0, 0),
      textAlign: 'right',
    },
    search: {
      position: 'relative',
      borderRadius: muiTheme.shape.borderRadius,
      marginLeft: 0,
      width: '100%',
      [muiTheme.breakpoints.up('sm')]: {
        marginLeft: muiTheme.spacing(1),
        width: 'auto',
      },
    },
    searchIcon: {
      padding: muiTheme.spacing(0, 1),
      height: '100%',
      pointerEvents: 'none',
    },
    icon: {},
    inputRoot: {
      color: 'inherit',
    },
    inputInput: {
      textAlign: 'right',
      padding: muiTheme.spacing(1, 1, 1, 0),
      paddingLeft: `calc(1em + ${muiTheme.spacing(4)}px)`,
      transition: muiTheme.transitions.create('width'),
      width: '100%',
      [muiTheme.breakpoints.up('sm')]: {
        width: '12ch',
        '&:focus': {
          width: '20ch',
        },
      },
    },
    menuIcon: {
      color: SecondaryColors.main,
    },
  }),
  { name: 'GenFilters' },
);

export default useStyles;
